/**
 * @file   network.js 网络管理模块
 * @author zhengchanglong<zhengchanglong@baidu.com>
 * @date   2020-12-31
 * @doc    https://console.cloud.baidu-int.com/devops/icode/repos/baidu/exp-fe/utils/blob/master:src/network.js
 */
import {Network} from '@baidu/exp-utils';
import config from '@config/index';
import errorMsg from '@config/error-msg';

export default new Network({
    errorMsg,
    headers: config.network.headers,
    timeout: config.network.timeout
});
